<template lang="pug">
app-page(title="Управление составами судьи")
  app-toolbar(:title="'Составы категорий для судьи - ' + judgeFullName" back) 

  app-group-animation
    app-group-item(v-for="c in listGroupCategory" :key="c.id" @click.native="toggleGroup(c)" cols="12")
      card-toggle(:title="'Состав - ' + c.name" :selected="isGroup(c)" data-aos="fade-top")
        div(v-if="c.caseCategory.length > 0")
          app-card-headline Количество категорий в составе: {{ c.caseCategory.length }}
          app-card-caption(v-for="cc in c.caseCategory" :key="cc.id") {{ cc.title }}
        div(v-if="c.uCaseCategory && c.uCaseCategory.length > 0")
          app-card-headline Количество статей в составе: {{ c.uCaseCategory.length }}
          app-card-caption(v-for="cc in c.uCaseCategory" :key="cc.id") - {{ cc.title }}

  button-back-page(@click.native="backJudge()") Готово
</template>

<script>
import { caseService, judgeService } from "@/_services";
import { mapState, mapGetters } from 'vuex'

import CardToggle from '../components/CardToggle'
import ButtonBackPage from '../components/ButtonBackPage'

export default {
  props: {
    judgeId: null
  },

  components: {
    CardToggle,
    ButtonBackPage
  },
  
  data () {
    return {
      listGroupCategory: [],
    }
  },

  mounted () {
    this.$store.commit('setInJudgeReestr', true)
    this.$store.dispatch('judgeReestr/INIT', { judgeId: this.judgeId })
    
    this.loadGroupCategory()
  },

  computed: {
    ...mapState('judgeReestr', ['currentJudge']),
    ...mapGetters('judgeReestr', ['judgeFullName']),
  },

  methods: {
    loadGroupCategory () {
      caseService.listGroupCategory()
      .then(data => {
        this.listGroupCategory = data
      })
    },

    isGroup(c) {
      if (this.currentJudge.caseCategoryGroup)
        return this.currentJudge.caseCategoryGroup.find(item => item.id === c.id)
    },

    toggleGroup (c) {
      if (this.isGroup(c))  this.currentJudge.caseCategoryGroup = this.currentJudge.caseCategoryGroup.filter (cat => c.id !== cat.id )
      else this.currentJudge.caseCategoryGroup.push(c)
    },

    backJudge () {
      judgeService.updateJudge(this.currentJudge).then(() => this.$router.push({ path: `/admin/judges/${this.judgeId}` }))
      
    },
  }
}
</script>


